import { render, staticRenderFns } from "./UserRoleView.vue?vue&type=template&id=d7f10a32"
import script from "./UserRoleView.vue?vue&type=script&lang=js"
export * from "./UserRoleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports